export default class CreateRateCardPositionRequest {
    positionId: string;
    chargeRate: number;
}